"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const config_1 = require("@completeanatomy/config");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const user_1 = require("@completeanatomy/user");
const styled_components_1 = __importStar(require("styled-components"));
const LanguageSelector_1 = __importDefault(require("../LanguageSelector"));
function AccountMenu({}) {
    const { t } = (0, i18n_1.useTranslation)();
    const currentUser = (0, user_1.useUser)();
    const config = (0, config_1.useConfigService)();
    const bridge = (0, bridge_1.useBridge)();
    const accountMenuButtons = [
        {
            label: t(i18n_1.Strings.toolbar.openInCompleteAnatomy),
            isSelected: false,
            key: t(i18n_1.Strings.toolbar.openInCompleteAnatomy),
            onClick: () => {
                window.open((config === null || config === void 0 ? void 0 : config.get('OPEN_IN_CA_LINK')) || '');
            },
        },
        {
            label: ((0, jsx_runtime_1.jsxs)("div", { children: [t(i18n_1.Strings.settings.preferences.features.language.name), ' ', (0, jsx_runtime_1.jsx)(LanguageSelector_1.default, {})] })),
            isSelected: false,
            key: 'language-selector',
            onClick: () => { },
        },
        {
            onClick: () => {
                window.location.href = (config === null || config === void 0 ? void 0 : config.get('MY_ACCOUNT_LINK')) || '';
            },
            label: t(i18n_1.Strings.profile.account.manageAccount),
            isSelected: false,
            key: t(i18n_1.Strings.profile.account.manageAccount),
        },
        {
            onClick: () => {
                var _a;
                // @ts-ignore
                if (window === null || window === void 0 ? void 0 : window.Optanon) {
                    // @ts-ignore
                    (_a = window.Optanon) === null || _a === void 0 ? void 0 : _a.ToggleInfoDisplay();
                }
            },
            label: t(i18n_1.Strings.firstLaunchOnboarding.privacy.sections.cookies.settingsBtn),
            isSelected: false,
            key: t(i18n_1.Strings.firstLaunchOnboarding.privacy.sections.cookies.settingsBtn),
            id: 'cookie-privacy-settings',
        },
        {
            onClick: () => {
                bridge === null || bridge === void 0 ? void 0 : bridge.logout();
            },
            label: t(i18n_1.Strings.profile.account.logout),
            isSelected: false,
            key: t(i18n_1.Strings.profile.account.logout),
        },
    ];
    return ((0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsxs)(UserInfo, { children: [(0, jsx_runtime_1.jsx)(StyledAvatar, { image: currentUser === null || currentUser === void 0 ? void 0 : currentUser.avatar, grasshopper: true }), (0, jsx_runtime_1.jsx)("p", { children: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name })] }), accountMenuButtons.map(({ onClick, isSelected, label, key, id }) => ((0, jsx_runtime_1.jsx)(StyledButton, { id: id, tabIndex: 0, onClick: onClick, isSelected: isSelected, children: label }, key)))] }));
}
exports.default = AccountMenu;
const StyledAvatar = (0, styled_components_1.default)(ui_1.Avatar) `
  width: 32px;
  height: 32px;
  background-color: ${({ theme }) => theme.grasshopper.avatar};
  display: inline-block;
  margin-right: 8px;
  flex-shrink: 0;
`;
const StyledButton = (0, styled_components_1.default)(ui_1.ToolBarBaseButton) `
  justify-content: left;
  padding: 8px 0px 8px 0px;
  z-index: unset;

  color: ${({ theme }) => theme.whiteSecondary};

  font-size: 16px;
  font-weight: 400;
  font-family: 'Elsevier Sans', sans-serif;

  ${({ isSelected, disabled }) => isSelected &&
    !disabled &&
    (0, styled_components_1.css) `
      background-color: inherit;
    `}
  ${({ isSelected, disabled }) => !isSelected &&
    !disabled &&
    (0, styled_components_1.css) `
      &:hover {
        background-color: inherit;
      }
    `}
`;
const UserInfo = styled_components_1.default.div `
  display: flex;
  align-items: center;
  font-weight: 700;

  font-size: 16px;
`;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 6px;
  display: flex;
  flex-direction: column;

  color: ${({ theme }) => theme.whiteSecondary};
`;
